/* global $, Modernizr, Modal */

$(function() {
    "use strict";

    $('form.tag-search').each(function () {
        var $root = $(this);

        $root.on('CitySelector::Change', function () {
            $root.submit();
        });

        if (Modernizr.csstransforms) {

            var $scrollable = $root.find('.tag-search__grid-scrollable-wrap');
            var watchingAtResize = false;

            var setTrianglePosition = _.throttle(function () {
                var $active   = $root.find('.tag-search__root-tag_active');
                var $triangle = $root.find('.tag-search__lesser-tags__triangle');

                if ($active.length > 0 && $triangle.parent(':visible').length > 0) {
                    var leftPosition = $active.position().left + $active.outerWidth(true) / 2 - $active.parents('.tag-search').position().left;

                    $triangle.show();
                    $triangle.css('left', leftPosition);
                    if (!watchingAtResize) {
                        $(window).on('resize.TagSearch', setTrianglePosition);
                        watchingAtResize = true;
                    }
                }
                else {
                    $triangle.hide();
                    $(window).off('resize.TagSearch');
                    watchingAtResize = false;
                }
            }, 100);

            $(document).on('ready', setTrianglePosition);
            $scrollable.on('scroll', setTrianglePosition);
            $root.on('TagFilter::TagsPaneToggled', setTrianglePosition);
        }

        var $childCategoriesTogglers = $('[data-tag-section-open-target]');

        $(document).on('click.TagSearch', $childCategoriesTogglers.selector, function (event) {
            var $toggler = $(this);
            var uuid = $toggler.data('tagSectionOpenTarget');
            var parentId = $toggler.closest('[data-pane-id]').data('paneId');
            var $targetPane;

            if (window.MediaQueryState.phones && window.MediaQueryState.isMobilised()) {
                event.preventDefault();
                $targetPane = $('#' + uuid + '_modal');

                _.defer(function () {
                    Modal.openModal(uuid + '_modal');
                });
            }
            else {
                if ($toggler.data('openWithoutReload')) {
                    $targetPane = $('#' + uuid + '_inline');

                    if ($targetPane.length > 0) {
                        event.preventDefault();
                    }

                    var $activeRoots = $root.find('.tag-search__root-tag_active');
                    var $paneRoot = $root.find('[data-root="' + $targetPane.data('rootTag') + '"]');
                    var $otherPanes = $root.find('.tag-search__lesser-tags');

                    if ($activeRoots.is($toggler)) {
                        $paneRoot.removeClass('tag-search__root-tag_active');
                        $targetPane.hide();
                        $root.trigger('TagFilter::TagsPaneToggled');
                    }
                    else {
                        $activeRoots.removeClass('tag-search__root-tag_active');
                        $paneRoot.addClass('tag-search__root-tag_active');
                        $otherPanes.hide();
                        $targetPane.show();
                        $root.trigger('TagFilter::TagsPaneToggled');
                    }
                }
            }

            if ($targetPane && $targetPane.length > 0 && !$toggler.is('.tag-search__back-button_real')) {
                $targetPane.find('.tag-search__back-button').data('tagSectionOpenTarget', parentId);
            }
        });

        var $tags       = $root.find('.tag-search__tags');
        var $tagsToggle = $tags.find('.tag-search__toggle');

        $(document).on('click.TagSearch', $tagsToggle.selector, function (event) {
            event.preventDefault();

            var $toggle = $(this);
            var $holders = $toggle.parents('.tag-search__lesser-tags').find('.tag-search__tags');

            $holders.toggle();

            $toggle.blur();
        });

        var tagsSelector;

        if ($root.hasClass('tag-search_space-cadet')) {
            tagsSelector = '.tag-search .js-tag-link';
        }
        else {
            tagsSelector = '.tag-search a';
        }

        $(document).on('click.TagSearch', tagsSelector, function () {
            $root.find('.search-form').addClass('search-form_submitting');
        });

        var $typeahead = $root.find('.typeahead');
        $typeahead.on('Typeahead::Change', function () {
            $root.submit();
        });
    });
});
